import React from 'react'

export default function RightAlignGridColumnHeader(props) {
  return (
    <span style={{ display:"flex",justifyContent:"end"}} >{props.title}</span>
  )
}
